import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Validators, UntypedFormGroup, UntypedFormBuilder, ValidatorFn, AbstractControl, ValidationErrors, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VariantType, DeletedetailsType } from '../shared/models/type-list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, NgIf, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFormField, MatInput, MatDialogActions, MatButton]
})
export class DeleteDialogComponent  {

  pitchID: string;
  pitchVariants: VariantType[] = [];

  deleteFormGroup: UntypedFormGroup;
  pitchFormType: string;
  variantcount:number;

  deleteList :DeletedetailsType[];
  totalwork :number;
  deleteVariant :boolean = false;
  uncheckedVariants : string [];
  uncheckedVariantswork : number;
  
  deletePitch :boolean = false;  

  displayDeleteionDetailsColumns: string[] = ['pitch_id','variant_count','total_work']
  
  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public deleteData: DeleteDialogData,
    private deleteFormBuilder: UntypedFormBuilder,
  ) 
  { 
    console.info(deleteData)
    this.deleteList = [];

    deleteData.pitch_id? this.pitchID = deleteData.pitch_id : this.pitchID = ''
    deleteData.pitchVariants ? this.pitchVariants = deleteData.pitchVariants : this.pitchVariants = []
    deleteData.pitchVariants ? this.variantcount = deleteData.pitchVariants.length : this.variantcount = 0
    deleteData.totalwork?this.totalwork=deleteData.totalwork : this.totalwork = 0
    deleteData.form_type ? this.pitchFormType = deleteData.form_type : this.pitchFormType = 'deletePitch'
    deleteData.uncheckedvariants ? this.uncheckedVariants = deleteData.uncheckedvariants : this.uncheckedVariants = []
    deleteData.uncheckedvariantswork ? this.uncheckedVariantswork = deleteData.uncheckedvariantswork : this.uncheckedVariantswork = 0

    let deletelist : DeletedetailsType = {
        pitch_id :this.pitchID,
        variant_count:this.variantcount,
        total_work:this.totalwork
         }
    this.deleteList.push(deletelist)
    
    if(this.pitchFormType == 'deleteVariant')
      {
        this.deleteVariant = true;
      }
    else if(this.pitchFormType == 'deletePitch')
      {
          this.deletePitch = true;
      }

    this.deleteFormGroup = this.deleteFormBuilder.group({
      form_deleteconfirmation: ['', [Validators.required,CustomValidators.confirmation]]
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmDelete(){
    if(this.deleteFormGroup.status == 'VALID'){
      const deleteFormData = {
        action: 'delete'
      }
      this.dialogRef.close(deleteFormData)
    } else {
      console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
    }
  }  
}

export class CustomValidators {
  static confirmation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    var isValid: Boolean = false;
    var confirmationvalue: string = control.value;
    console.log("calling custom validator")
    console.log(confirmationvalue)
    if(confirmationvalue== "YES" ){
      
      isValid = true;
    }else{
      isValid = false;
      console.log("Confirmation should be typed in as 'YES' ")
    }
    console.log(isValid)

    return isValid ? null : { confirmation: true };
  }
}

export interface DeleteDialogData {
  team_name?: string;
  version_name?: string;
  pitch_config_id: string;
  pitch_id: string;
  pitchVariants: VariantType[];
  totalwork:number;
  can_delete?: boolean;
  form_type: string;
  uncheckedvariants :string[];
  uncheckedvariantswork :number;
  region? : string;
  subline? :string;
  line? :string;
  num_pitches? : number;
  variant_name?: string;
}
